export enum AddressChoiceEnum {
  Form = 'form',
  Select = 'select',
}

export interface IPostClaimCta {
  label: string;
  url: string;
  countdownSeconds: number;
}

export interface IPostClaimScenarioConfig extends Partial<IPostClaimCta> {
  scenario: string;
}
